import { B400, B50, N10, N30, N500 } from '@atlaskit/theme/colors';
export var navigationBackgroundColor = N10;
export var itemHoverBackgroundColor = N30;
export var itemActiveBackgroundColor = B50;
export var itemTextColor = N500;
export var itemTextSelectedColor = B400;
export var separatorColor = N30;